import { COLORS } from '@btime/constants'
import { compose, mapObjIndexed, values } from 'ramda'
import React from 'react'

import Tag from '../../../components/presentation/Tag'

const LogTags = ({ tags }) => {
  if (!tags) return '-'

  return (
    <>
      {compose(
        values,
        mapObjIndexed((value, key) => <Tag key={key} label={`${key}: ${value}`} color={COLORS.dark5} size="xxxsmall" />)
      )(tags)}
    </>
  )
}

export default LogTags
